import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useLink } from 'react-aria';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const Link = ({ href, target, children, ...props }) => {
    const ref = useRef();
    const { linkProps } = useLink(props, ref);

    return (
        <li
            className="govuk-header__navigation-item"
            role="none"
        >
            <a
                ref={ref}
                {...linkProps}
                className="govuk-header__link"
                href={href}
                role="menuitem"
                target={target}
            >
                {children}
            </a>
        </li>
    );
};

Link.propTypes = {
    ...defaultAriaProps,
    href: PropTypes.string.isRequired,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top', 'framename']),
    children: PropTypes.any
};

Link.defaultProps = {
    target: '_self'
};

export default Link;
